module.exports = __webpack_public_path__ + "img/2.c27f4ee1.jpg";